module.exports = __webpack_public_path__ + "eb2b82c57dda81c9aa7546a27b8399c1.png";